import { RequestContext, GetTitlesInput } from 'DVWebNodeUtils'
import { getEpisodeListPresentationScheme } from '../utils/domainUtils';

export const getTitleInputForEpisodeRefresh = (context: RequestContext, canonicalTitleId: string) => ({
    context,
    titleIDs: [canonicalTitleId],
    fragments: ['Action', 'Refund'],
    presentationScheme: getEpisodeListPresentationScheme(context.domain || 'Fogg')
} as GetTitlesInput)